const CLINICIAN_APP_HOSTS = new Set(['portal.invogenix.app']);
const CLINICIAN_PREVIEW_PATH = '/app-preview';
const PUBLIC_DEMO_PATHS = ['/c/', '/public-demo'];

export const isClinicianAppLocation = (locationObject) => {
  if (!locationObject) {
    return false;
  }

  const hostname = locationObject.hostname || '';
  const pathname = locationObject.pathname || '';

  return (
    CLINICIAN_APP_HOSTS.has(hostname) ||
    pathname.startsWith(CLINICIAN_PREVIEW_PATH) ||
    PUBLIC_DEMO_PATHS.some((path) => pathname === path || pathname.startsWith(path))
  );
};

export const clinicianPreviewPath = CLINICIAN_PREVIEW_PATH;
